<template>
    <div class="modal-card card">
        <form @submit.prevent="onSaveTag()">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">
                Save Tag Template
            </h4>
            <!-- Close -->
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div class="card-body">
                <form-fields v-if="!message" :fields="fields" v-model="tagData" />
                <div v-if="error" class="text-danger">
                    {{error}}
                </div>
                <div v-if="message">
                    {{ message }}
                </div>
        </div>
        <div class="card-footer" v-if="!message">
            <div class="text-end">
                <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">
                    Cancel
                </button>
                <submit-button :fields="fields" v-model="tagData" :loading="loading" button-text="Save" />
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import formFields from '../FormFields.vue';
import submitButton from '../SubmitButton.vue'
import {mapActions} from 'vuex'

export default {
    components: { formFields, submitButton },
    data(){
        return {
            error: "",
            message: "",
            tagData: {},            
            fields: [
                {
                    name: 'name',
                    label: 'Tag Template Name',
                    type: 'text',
                    placeholder: 'Enter tag template name',
                    validation: [
                        { type: "required", errMsg: "Tag Template name is required" }
                    ]
                }
            ],
            loading: false
        }
    },
    props: {
       modalData: {
            type: Object,
            default: () => ({})
        }
    },
    name: "SaveTagModal",    
    methods: {
        ...mapActions({
            showModal: "showModal"
        }),
        async onSaveTag() {
            this.loading = true;
            this.error = "";
            try {
                if (this.modalData && this.modalData.onSave && typeof this.modalData.onSave === 'function') {
                    await this.modalData.onSave(this.tagData.name);
                }
                this.$store.dispatch("hideModal");
            } catch (error) {                
                console.error('Error saving tag template:', error);
                this.error = "Failed to save tag template '" + this.tagData.name + "'. Please try again.";
                
            }

            this.loading = false;
        }
    }
};
</script>

<style>
</style>
